import { TrackingRegion } from '../../../common/AnalyticsContext/TrackingData';
import { ButtonGroup } from '../../../common/components/Button/ButtonGroup.styles';
import { StyledLinkButton } from '../../../common/components/Button/StyledButtons';
import { Heading } from '../../../common/components/Typography/Heading/Heading';
import { Kicker } from '../../../common/components/Typography/Heading/Heading.styles';
import { Paragraph } from '../../../common/components/Typography/Paragraph/Paragraph';
import {
  HealthcareProviderGraphic,
  HealthcareProviderPageSection,
  HealthcareProviderSectionLeftCol,
  HealthcareProviderSectionRightCol,
  HealthcareProviderSectionRow,
} from './HealthCareProviderSection.styles';

export const HealthCareProviderSection = () => (
  <HealthcareProviderPageSection trackingRegionId={TrackingRegion.HEALTHCARE_PROVIDER}>
    <HealthcareProviderSectionRow>
      <HealthcareProviderSectionLeftCol>
        <HealthcareProviderGraphic
          src="/public/images/he_join_20210808060323.png"
          htmlAttributes={{ alt: 'Healthengine Healthcare Platform practitioner' }}
          imgixParams={{
            auto: 'enhance',
          }}
        />
      </HealthcareProviderSectionLeftCol>
      <HealthcareProviderSectionRightCol>
        <Kicker>Are you a healthcare provider?</Kicker>
        <Heading h3>Join Australia's #1 healthcare platform.</Heading>
        <Paragraph>
          We’re making it easier for practices to connect with patients. Easier for you to fill your
          books. Easier for you to step up your patient experience game.
          <ul>
            <li>Be 'always on' for patients even when you switch off after hours</li>
            <li>Fill costly gaps in your appointment calendar</li>
            <li>Power-up your practice with our efficiency tools</li>
          </ul>
        </Paragraph>

        <ButtonGroup>
          <StyledLinkButton to="https://practices.healthengine.com.au/list-your-practice/?pracsource=homepage">
            List your practice
          </StyledLinkButton>
          <StyledLinkButton
            to="https://practices.healthengine.com.au/?pracsource=homepage"
            options={{ keyline: true }}
          >
            Learn more
          </StyledLinkButton>
        </ButtonGroup>
      </HealthcareProviderSectionRightCol>
    </HealthcareProviderSectionRow>
  </HealthcareProviderPageSection>
);
